import { useLocation, useNavigate } from "react-router-dom";
import { SideBarWrapper } from "./style/sideBar";
import {
  LOCAL_STORAGE_ACCESS_KEY,
  LOCAL_STORAGE_PUB_ID,
  LOCAL_STORAGE_SUPER_ADMIN_KEY,
} from "../utils/network";
import { useEffect, useMemo, useState } from "react";
import { useRecoilValue } from "recoil";
import { pubState } from "../recoil/pub.atom";
import { PubDetail, PubOwnerRole } from "../api/cafe";
import { getPubList, getSellerToken } from "../api/admin-pub";
import SearchableDropdown from "../component/SearchableDropdown";
import { DEFAULT_MENU, MENU } from "./utile/side-bar.utile";
import LogoutDialog from "./logout";

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pub = useRecoilValue(pubState);
  const [openMenu, setOpenMenu] = useState<string>("");
  const [franchiseList, setFranchiseList] = useState<PubDetail[]>([]);
  const [isLogout, setIsLogout] = useState(false);

  const superAdminToken = localStorage.getItem(LOCAL_STORAGE_SUPER_ADMIN_KEY);

  const menu = useMemo(() => {
    if (!pub) return [];
    if (pub.role === PubOwnerRole.OWNER || pub?.domains.length === 0)
      return MENU;

    const filtered = MENU.filter(
      (item) => item.domain && pub.domains.includes(item.domain),
    );

    return [...DEFAULT_MENU, ...filtered];
  }, [pub]);

  const toggleMenu = (path: string) => {
    if (path === openMenu) {
      setOpenMenu("");
      return;
    }
    setOpenMenu(path);
  };

  const isPathMatch = (path: string, pathname: string) => {
    const basePath = pathname.split("/")[1];
    return path === "/" + basePath;
  };

  const getFranchises = async () => {
    if (!superAdminToken) return;
    const res = await getPubList();
    setFranchiseList(res);
  };

  useEffect(() => {
    getFranchises();
  }, []);

  const handleChangeFranchise = async (pubId: number) => {
    try {
      const sellerToken = await getSellerToken(pubId);
      localStorage.setItem(
        LOCAL_STORAGE_ACCESS_KEY,
        `Bearer ${sellerToken.accessToken}`,
      );
      localStorage.setItem(LOCAL_STORAGE_PUB_ID, pubId.toString());
      window.location.reload();
    } catch (e) {
      alert("해당 펍에 접근할 수 없습니다.");
    }
  };

  return (
    <SideBarWrapper>
      {isLogout && <LogoutDialog onClose={() => setIsLogout(false)} />}
      <div className="header">
        {superAdminToken && (
          <SearchableDropdown
            options={franchiseList}
            selectedValue={pub?.id}
            onSelect={handleChangeFranchise}
            placeholder="펍을 검색하세요..."
          />
        )}
        <img
          src="/image-web/logo/admin_logo.svg"
          alt="Admin Logo"
          onClick={() => navigate("/")}
        />
      </div>
      <div className="body">
        {menu.map((item, index) => (
          <>
            <div
              className="item"
              key={index}
              onClick={(e) => {
                if (item.children) {
                  e.stopPropagation();
                  toggleMenu(item.path[0]);
                } else {
                  navigate(item.path[0]);
                }
              }}
            >
              <div
                className={`line ${item.path.some(
                  (path) =>
                    isPathMatch(path, location.pathname) ||
                    (path !== "/"
                      ? location.pathname.startsWith(path) && "active"
                      : path === location.pathname && "active"),
                )}`}
              />
              <div
                className={`icon-back ${item.path.some(
                  (path) =>
                    isPathMatch(path, location.pathname) ||
                    (path !== "/" &&
                      location.pathname.startsWith(path) &&
                      "white"),
                )}`}
              >
                <img
                  src={`/image-web/menu/${item.icon}`}
                  style={{
                    filter: item.path.some(
                      (path) =>
                        isPathMatch(path, location.pathname) ||
                        (path !== "/" && location.pathname.startsWith(path)),
                    )
                      ? "invert(74%) sepia(0%) saturate(2132%) hue-rotate(15deg) brightness(84%) contrast(98%)"
                      : "invert(21%) sepia(1%) saturate(1817%) hue-rotate(5deg) brightness(89%) contrast(91%)",
                  }}
                  alt="menu icon"
                />
              </div>

              <div
                className="title"
                style={{
                  color: item.path.some(
                    (path) =>
                      isPathMatch(path, location.pathname) ||
                      (path !== "/" && location.pathname.startsWith(path)),
                  )
                    ? "#FFF"
                    : "#9C9C9C",
                }}
              >
                {item.name}
                {item.children && (
                  <img
                    src={`/image-web/menu/${
                      item.path.some(
                        (path) =>
                          isPathMatch(path, location.pathname) ||
                          openMenu === path,
                      )
                        ? "up"
                        : "down"
                    }.svg`}
                    alt="toggle"
                  />
                )}
              </div>
            </div>
            {item.path.some((path) => openMenu === path) && item.children && (
              <div className="child">
                {item.children.map((child, childIndex) => (
                  <div
                    className="item"
                    style={{
                      color: child.path.some(
                        (path) =>
                          isPathMatch(path, location.pathname) ||
                          (path !== "/" && location.pathname.startsWith(path)),
                      )
                        ? "#FFF"
                        : "#9C9C9C",
                    }}
                    key={childIndex}
                    onClick={() => {
                      navigate(child.path[0]);
                    }}
                  >
                    {child.name}
                  </div>
                ))}
              </div>
            )}
          </>
        ))}
      </div>
      <div className="log-out" onClick={() => setIsLogout(true)}>
        LOGOUT
      </div>
    </SideBarWrapper>
  );
};
export default SideBar;
